import HttpService from './http.service';
import { currentSegmentSeriesGroup } from './cadService';
import { getMembersFromMembers, allSegments } from './tactonService';
import { getMembersFromRootMember } from './tactonService';
import { currentSegmentSelectionMembers } from './cadService';

const getHoseAssemblyPrice = async selections => {
  try {
    var response = await HttpService.postByObject(
      '/Pricing/GetHoseAssemblyPrice',
      selections
    );
    return response.data;
  } catch {
    return '';
  }
};

const getPricefromLegacyPriceSheets = async (sessionData, response) => {
  let currentStep = response?.tactonModel.steps.filter(x => x.current)[0];

  if (!currentStep) return;

  var configSelection = await getLegacyControlValue(
    sessionData,
    currentStep,
    response
  );
  if (configSelection != null) {
    var price = await getPrice(configSelection);
    return price;
  }
};

const getLegacyControlValue = async (sessionData, step, response) => {
  let configSelection = {};
  let controlValues = [];
  let legData;
  configSelection.Division = sessionData.manufacturingLocation;
  configSelection.Series = sessionData.configModel;
  configSelection.sellDivision = sessionData.sellDivision;
  configSelection.customerLocation = sessionData.customerLocation;
  configSelection.customerNumber = sessionData.customerNumber;
  //**************NEED TO CHECK THIS SECTION WITH ACTUAL SESSION ID WITH SESS>OPTION=100*************

  var divisionMembers = step.rootGroup.members.filter(x =>
    x.name.includes('division_group')
  );
  if (divisionMembers.length <= 0)
    divisionMembers = step.rootGroup.members.filter(x =>
      x.name.includes('ui_group')
    );
  if (divisionMembers.length <= 0) return null;

  let uiMembers = getMembersFromRootMember(divisionMembers[0]);

  //get selection members
  if (response.isManifoldProduct) {
    var segmentStep = response.segmentStep;
    if (segmentStep != null && segmentStep.hasOwnProperty('rootGroup')) {
      var allSegments = segmentStep.rootGroup.members.filter(
        x => x.name.includes('segment') && x.hasVisibleParameters
      );
      var segment = allSegments[allSegments.length - 1];
      var parentSelectionMembers = currentSegmentSelectionMembers(segment);
      if (parentSelectionMembers.length > 0) {
        uiMembers.push(...parentSelectionMembers);
      }
    }
  }

  var legacydata = await getCadXmlData(
    configSelection.Division,
    configSelection.Series
  );
  if (legacydata.length > 0) {
    for (var i = 0; i < uiMembers.length; i++) {
      if (uiMembers[i].domain?.name.endsWith('class'))
        legData = legacydata.filter(x => x['TACTON_KEY'] == uiMembers[i].value);
      else
        legData = legacydata.filter(x => x['TACTON_KEY'] == uiMembers[i].name);

      if (legData.length > 0) {
        var ctrlObj = new Object();
        ctrlObj.ControlNumber = legData[0]['CONTROL_NUM'];
        ctrlObj.ValueNumber = legData[0]['VALUE_NUM'];
        ctrlObj.ModelValue = uiMembers[i].valueDescription;
        controlValues.push(ctrlObj);
      }
    }

    configSelection.ControlValues = controlValues;
    return configSelection;
  }
  return null;
};

const getPrice = async priceModel => {
  try {
    var result = await HttpService.postByObject(
      `Pricing/GetPriceandLeadtime`,
      priceModel
    );
    return result.data;
  } catch {
    return {
      priceAmt: 0,
      currencyCode: '',
      currencySymbol: ''
    };
  }
};

const getCadXmlData = async (division, configModel) => {
  var result = await HttpService.get(
    `LegacyConfigData/GetControlsValuesAndTactonKeys?divisionID=${division}&partno=${configModel}`
  );
  return result.data;
};

const getTotalPriceforSegmentandAssembly = async (
  editedManifoldSegmentforPrice,
  response,
  manifoldPrices,
  sessionData
) => {
  for (let segmentName of editedManifoldSegmentforPrice) {
    if (segmentName !== '') {
      if (segmentName == 'manifold') {
        var manifoldStep = response.tactonModel.steps.filter(x =>
          x.name.includes('manifold')
        )[0];
        manifoldPrices = await getPriceforAssembly(
          manifoldStep,
          manifoldPrices,
          sessionData,
          response
        );
      } else {
        //calculate price for the current segment if it is commited
        var allActiveSection = allSegments(response);
        var stationIndex = allActiveSection.findIndex(
          x => x.name === segmentName
        );
        manifoldPrices = await getPriceforSegment(
          allActiveSection[stationIndex],
          manifoldPrices,
          sessionData
        );
      }
    }
  }

  let priceLeadTime = await calcTotalPriceforAssemblyConfig(manifoldPrices);
  //store.editedManifoldSegmentforPrice = [];
  return {
    priceLeadTime: priceLeadTime,
    manifoldPrices: manifoldPrices
  };
};

const getPriceforAssemblyandSegment = async (
  response,
  manifoldPrices,
  sessionData
) => {
  var totalPrice;

  var availableSteps = response.tactonModel.steps.filter(
    x =>
      x.available == true &&
      !x.name.includes('initial_step') &&
      !x.name.includes('order_summary')
  );

  for (let step of availableSteps) {
    if (step.name.includes('manifold')) {
      if (!step.hasOwnProperty('rootGroup')) return totalPrice;
      manifoldPrices = await getPriceforAssembly(
        step,
        manifoldPrices,
        sessionData,
        response
      );
    } else if (
      step.name.includes('segment') &&
      step.hasOwnProperty('rootGroup')
    ) {
      var allSegments = step.rootGroup.members.filter(
        x =>
          x.name.includes('segment') &&
          !x.name.includes('segment_init') &&
          x.hasVisibleParameters
      );
      for (let segment of allSegments) {
        manifoldPrices = await getPriceforSegment(
          segment,
          manifoldPrices,
          sessionData
        );
      }
    }
  }

  totalPrice = await calcTotalPriceforAssemblyConfig(manifoldPrices);
  return {
    priceLeadTime: totalPrice,
    manifoldPrices: manifoldPrices
  };
};

const getPriceforAssembly = async (
  step,
  manifoldPrices,
  sessionData,
  response
) => {
  var totalPrice;
  // var manifoldPrices: ManifoldPrices[] = [];
  var manifoldPrice = {
    segmentName: '',
    priceAmt: 0,
    currencyCode: '',
    currencySymbol: ''
  };
  var configSelection = await getLegacyControlValue(
    sessionData,
    step,
    response
  );
  if (configSelection != null) totalPrice = await getPrice(configSelection);
  var existingManifoldPrice = manifoldPrices.filter(
    x => x.segmentName == 'manifold'
  );
  if (existingManifoldPrice.length > 0)
    existingManifoldPrice[0].priceAmt = totalPrice?.priceAmt;
  else {
    manifoldPrice.segmentName = 'manifold';
    manifoldPrice.priceAmt = totalPrice?.priceAmt;
    manifoldPrice.currencyCode = totalPrice?.currencyCode;
    manifoldPrice.currencySymbol = totalPrice?.currencySymbol;
    manifoldPrices.push(manifoldPrice);
  }
  return manifoldPrices;
};

const getPriceforSegment = async (segment, manifoldPrices, sessionData) => {
  if (segment) {
    var Price;
    var newsegmentPrice = {
      segmentName: '',
      priceAmt: 0,
      currencyCode: '',
      currencySymbol: ''
    };
    var configSelection = await getLegacyControlValueforSegment(
      segment,
      sessionData
    );

    if (configSelection != null) Price = await getPrice(configSelection);
    var segmentPrice = manifoldPrices.filter(
      x => x.segmentName == segment.name
    );
    if (segmentPrice.length > 0) segmentPrice[0].priceAmt = Price?.priceAmt;
    else {
      newsegmentPrice.segmentName = segment.name;
      newsegmentPrice.priceAmt = Price?.priceAmt;
      newsegmentPrice.currencyCode = Price?.currencyCode;
      newsegmentPrice.currencySymbol = Price?.currencySymbol;
      manifoldPrices.push(newsegmentPrice);
    }
  }
  return manifoldPrices;
};

const getLegacyControlValueforSegment = async (segment, sessionData) => {
  let configSelection = {};
  let ControlValues = [];
  var legData;
  var uiMembers;
  configSelection.Division = sessionData.manufacturingLocation;

  configSelection.sellDivision = sessionData.sellDivision;
  configSelection.customerLocation = sessionData.customerLocation;
  configSelection.customerNumber = sessionData.customerNumber;
  //get the segment series members selections
  var uiGroup = currentSegmentSeriesGroup(segment);
  if (uiGroup.length > 0) {
    // var index = uiGroup[0].description.lastIndexOf('-');
    // if (index > 0)
    configSelection.Series = uiGroup[0].description;
    uiMembers = getMembersFromMembers(uiGroup[0]);

    var legacydata = await getLegacyConfigData(
      configSelection.Division,
      configSelection.Series
    );
    if (legacydata.length > 0) {
      ControlValues = [];

      for (let member of uiMembers) {
        if (member.domain.name.endsWith('class'))
          legData = legacydata.filter(x => x['TACTON_KEY'] == member.value);
        else {
          //to remove the last digit for repeated field names in segments 1 to 32
          if (member.name.includes('_field_')) {
            var index = member.name.lastIndexOf('_');
            legData = legacydata.filter(
              x => x['TACTON_KEY'] == member.name.substring(0, index)
            );
          } else {
            legData = legacydata.filter(x => x['TACTON_KEY'] == member.name);
          }
        }

        if (legData.length > 0) {
          var ctrlObj = new Object();
          ctrlObj.ControlNumber = legData[0]['CONTROL_NUM'];
          ctrlObj.ValueNumber = legData[0]['VALUE_NUM'];
          ctrlObj.ModelValue = member.valueDescription;
          ControlValues.push(ctrlObj);
        }
      }
      configSelection.ControlValues = ControlValues;
      return configSelection;
    }
    return null;
  }
};

const getLegacyConfigData = async (division, series) => {
  var result = await HttpService.get(
    `LegacyConfigData/GetControlsValuesAndTactonKeys?divisionID=${division}&partno=${series}`
  );
  return result.data;
};

const calcTotalPriceforAssemblyConfig = async manifoldPrices => {
  var totalPrice = {
    currencySymbol: '',
    priceAmt: 0,
    currencyCode: '',
    leadTime: ''
  };
  for (let manifoldPrice of manifoldPrices) {
    if (manifoldPrice.segmentName == 'manifold') {
      totalPrice.currencyCode = manifoldPrice.currencyCode;
      totalPrice.currencySymbol = manifoldPrice.currencySymbol;
    }
    if (manifoldPrice.priceAmt)
      totalPrice.priceAmt = totalPrice.priceAmt + manifoldPrice.priceAmt;
  }
  return totalPrice;
};

const removePriceforSegment = async (
  segment,
  response,
  manifoldPrices,
  sessionData
) => {
  var manifoldStep = response.tactonModel.steps.filter(x =>
    x.name.includes('manifold')
  )[0];
  manifoldPrices = await getPriceforAssembly(
    manifoldStep,
    manifoldPrices,
    sessionData,
    response
  );
  var segmentPriceIndex = manifoldPrices.findIndex(
    x => x.segmentName == segment.name
  );
  if (segmentPriceIndex > -1) {
    manifoldPrices.splice(segmentPriceIndex);
  }
  let priceLeadTime = await calcTotalPriceforAssemblyConfig(manifoldPrices);
  return {
    priceLeadTime: priceLeadTime,
    manifoldPrices: manifoldPrices
  };
};

export {
  getHoseAssemblyPrice,
  getPricefromLegacyPriceSheets,
  getTotalPriceforSegmentandAssembly,
  getPriceforAssemblyandSegment,
  removePriceforSegment
};
